"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.finalDispatch = exports.dispatch = exports.subscribe = void 0;
var mobx_1 = require("mobx");
var actionCreator_1 = require("./actionCreator");
var globalContext_1 = require("./globalContext");
function subscribe(actionId, callback) {
    var subscriptions = globalContext_1.getGlobalContext().subscriptions;
    if (!subscriptions[actionId]) {
        subscriptions[actionId] = [];
    }
    subscriptions[actionId].push(callback);
}
exports.subscribe = subscribe;
function dispatch(actionMessage) {
    var currentMutator = globalContext_1.getGlobalContext().currentMutator;
    if (currentMutator) {
        throw new Error("Mutator (" + currentMutator + ") may not dispatch action (" + actionMessage.type + ")");
    }
    var dispatchWithMiddleware = globalContext_1.getGlobalContext().dispatchWithMiddleware || finalDispatch;
    mobx_1.transaction(dispatchWithMiddleware.bind(null, actionMessage));
}
exports.dispatch = dispatch;
function finalDispatch(actionMessage) {
    var actionId = actionCreator_1.getPrivateActionId(actionMessage);
    var subscribers = globalContext_1.getGlobalContext().subscriptions[actionId];
    if (subscribers) {
        var promises = [];
        for (var _i = 0, subscribers_1 = subscribers; _i < subscribers_1.length; _i++) {
            var subscriber = subscribers_1[_i];
            var returnValue = subscriber(actionMessage);
            if (returnValue) {
                promises.push(returnValue);
            }
        }
        if (promises.length) {
            return promises.length == 1 ? promises[0] : Promise.all(promises);
        }
    }
}
exports.finalDispatch = finalDispatch;
